/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestBoxInfo } from './RequestBoxInfo';
import {
    RequestBoxInfoFromJSON,
    RequestBoxInfoFromJSONTyped,
    RequestBoxInfoToJSON,
    RequestBoxInfoToJSONTyped,
} from './RequestBoxInfo';

/**
 * 
 * @export
 * @interface RequestCreateDeliveryOptionsRequest
 */
export interface RequestCreateDeliveryOptionsRequest {
    /**
     * Packing情報
     * PackingGroupIds []string  `json:"packing_group_ids" validate:"required"` // 複数対応
     * @type {Array<RequestBoxInfo>}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    boxes: Array<RequestBoxInfo>;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    contactEmail: string;
    /**
     * 配送連絡先
     * @type {string}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    contactName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    contactPhone: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    deleveryEndDate: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    deleveryStartDate: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    groupNum: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    isApiPlan: boolean;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    planId: number;
    /**
     * 出荷ウィンドウ
     * @type {string}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    readyToShipStart: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    tenantId: number;
    /**
     * 配送方法
     * @type {number}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    transportationOptionId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateDeliveryOptionsRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestCreateDeliveryOptionsRequest interface.
 */
export function instanceOfRequestCreateDeliveryOptionsRequest(value: object): value is RequestCreateDeliveryOptionsRequest {
    if (!('boxes' in value) || value['boxes'] === undefined) return false;
    if (!('contactEmail' in value) || value['contactEmail'] === undefined) return false;
    if (!('contactName' in value) || value['contactName'] === undefined) return false;
    if (!('contactPhone' in value) || value['contactPhone'] === undefined) return false;
    if (!('deleveryEndDate' in value) || value['deleveryEndDate'] === undefined) return false;
    if (!('deleveryStartDate' in value) || value['deleveryStartDate'] === undefined) return false;
    if (!('groupNum' in value) || value['groupNum'] === undefined) return false;
    if (!('isApiPlan' in value) || value['isApiPlan'] === undefined) return false;
    if (!('planId' in value) || value['planId'] === undefined) return false;
    if (!('readyToShipStart' in value) || value['readyToShipStart'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestCreateDeliveryOptionsRequestFromJSON(json: any): RequestCreateDeliveryOptionsRequest {
    return RequestCreateDeliveryOptionsRequestFromJSONTyped(json, false);
}

export function RequestCreateDeliveryOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateDeliveryOptionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'boxes': ((json['boxes'] as Array<any>).map(RequestBoxInfoFromJSON)),
        'contactEmail': json['contact_email'],
        'contactName': json['contact_name'],
        'contactPhone': json['contact_phone'],
        'deleveryEndDate': json['delevery_end_date'],
        'deleveryStartDate': json['delevery_start_date'],
        'groupNum': json['group_num'],
        'isApiPlan': json['is_api_plan'],
        'planId': json['plan_id'],
        'readyToShipStart': json['ready_to_ship_start'],
        'tenantId': json['tenant_id'],
        'transportationOptionId': json['transportation_option_id'] == null ? undefined : json['transportation_option_id'],
        'userId': json['user_id'],
    };
}

export function RequestCreateDeliveryOptionsRequestToJSON(json: any): RequestCreateDeliveryOptionsRequest {
    return RequestCreateDeliveryOptionsRequestToJSONTyped(json, false);
}

export function RequestCreateDeliveryOptionsRequestToJSONTyped(value?: RequestCreateDeliveryOptionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxes': ((value['boxes'] as Array<any>).map(RequestBoxInfoToJSON)),
        'contact_email': value['contactEmail'],
        'contact_name': value['contactName'],
        'contact_phone': value['contactPhone'],
        'delevery_end_date': value['deleveryEndDate'],
        'delevery_start_date': value['deleveryStartDate'],
        'group_num': value['groupNum'],
        'is_api_plan': value['isApiPlan'],
        'plan_id': value['planId'],
        'ready_to_ship_start': value['readyToShipStart'],
        'tenant_id': value['tenantId'],
        'transportation_option_id': value['transportationOptionId'],
        'user_id': value['userId'],
    };
}

